// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
export function login(data) {
  return request({
    url: '/admin/platform/login',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/admin/platform/getAdminInfoByToken',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/admin/platform/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
export function userListApi(params) {
  return request({
    url: "/admin/platform/user/list",
    method: 'get',
    params: params
  });
}
/**
 * 会员伯乐 列表
 * @param pram
 */
export function userBoleListApi(params) {
  return request({
    url: "/admin/agent/bole/list",
    method: 'get',
    params: params
  });
}
/**
 * 会员伯乐 编辑
 * @param pram
 */
export function userBoleEditApi(params) {
  return request({
    url: "/admin/agent/bole/edit",
    method: 'get',
    params: params
  });
}
/**
 * 会员伯乐 日志
 * @param pram
 */
export function userBoleLogInfoApi(params) {
  return request({
    url: "/admin/agent/bole/info",
    method: 'get',
    params: params
  });
}
/**
 * 会员活跃 列表
 * @param pram
 */
export function userActiveListApi(params) {
  return request({
    url: "/admin/platform/user/active/list",
    method: 'get',
    params: params
  });
}
/**
 * 会员活跃新增
 * @param pram
 */
export function userActiveAddApi(params) {
  return request({
    url: "/admin/platform/user/active/add",
    method: 'get',
    params: params
  });
}
/**
 * 会员活跃编辑
 * @param pram
 */
export function userActiveEditApi(params) {
  return request({
    url: "/admin/platform/user/active/edit",
    method: 'get',
    params: params
  });
}
/**
 * 会员活跃日志
 * @param pram
 */
export function userActiveLogInfoApi(params) {
  return request({
    url: "/admin/platform/user/active/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 修改
 * @param pram
 */
export function userUpdateApi(params, data) {
  return request({
    url: "/admin/platform/user/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员管理等级 修改
 * @param pram
 */
export function userLevelUpdateApi(data) {
  return request({
    url: "/admin/user/update/level",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 详情
 * @param pram
 */
export function userInfoApi(params) {
  return request({
    url: "/admin/user/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情
 * @param pram
 */
export function infobyconditionApi(params) {
  return request({
    url: "/admin/user/infobycondition",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情top数据
 * @param pram
 */
export function topdetailApi(params) {
  return request({
    url: "/admin/user/topdetail",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 批量设置分组
 * @param pram
 */
export function groupPiApi(params) {
  return request({
    url: "/admin/user/group",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 批量设置标签
 * @param pram
 */
export function tagPiApi(data) {
  return request({
    url: "/admin/platform/user/tag",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 积分余额
 * @param pram
 */
export function foundsApi(params) {
  return request({
    url: "/admin/platform/user/operate/integer",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 积分余额
 * @param pram
 */
export function balanceApi(params) {
  return request({
    url: "/admin/platform/user/operate/balance",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 删除
 * @param pram
 */
export function userDeleteApi(params) {
  return request({
    url: "/admin/user/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 列表
 * @param pram
 */
export function levelListApi() {
  return request({
    url: "/admin/platform/system/user/level/list",
    method: 'get'
  });
}

/**
 * 会员等级 新增
 * @param pram
 */
export function levelSaveApi(data) {
  return request({
    url: "/admin/platform/system/user/level/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 编辑
 *  @param pram
 */
export function levelUpdateApi(data) {
  return request({
    url: "/admin/platform/system/user/level/update",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 详情
 * @param pram
 */
export function levelInfoApi(params) {
  return request({
    url: "/admin/system/user/level/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 删除
 * @param pram
 */
export function levelDeleteApi(id) {
  return request({
    url: "/admin/platform/system/user/level/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 会员等级 是否显示
 * @param pram
 */
export function levelUseApi(data) {
  return request({
    url: "/admin/platform/system/user/level/use",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 列表
 * @param pram
 */
export function tagListApi(params) {
  return request({
    url: "/admin/platform/user/tag/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 新增
 * @param pram
 */
export function tagSaveApi(data) {
  return request({
    url: "/admin/platform/user/tag/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 编辑
 * @param pram
 */
export function tagUpdateApi(data) {
  return request({
    url: "/admin/platform/user/tag/update",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 详情
 * @param pram
 */
export function tagInfoApi(params) {
  return request({
    url: "/admin/user/tag/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 删除
 * @param pram
 */
export function tagDeleteApi(id) {
  return request({
    url: "/admin/platform/user/tag/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 用户标签全部列表
 */
export function tagAllListApi(id) {
  return request({
    url: "/admin/platform/user/tag/all/list",
    method: 'get'
  });
}

/**
 *获取登录页图片
 */
export function getLoginPicApi() {
  return request({
    url: "/admin/platform/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
export function captchaApi() {
  return request({
    url: "/publicly/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 修改上级推广人
 */
export function updateSpreadApi(data) {
  return request({
    url: "/admin/platform/retail/store/update/user/spread",
    method: 'post',
    data: data
  });
}

/**
 * @description 修改手机号
 */
export function updatePhoneApi(params) {
  return request({
    url: "/admin/user/update/phone",
    method: 'get',
    params: params
  });
}

/**
 * @description 用户详情列表
 */
export function userDetailApi(id) {
  return request({
    url: "/admin/platform/user/detail/".concat(id),
    method: 'get'
  });
}

/**
 * @description 获取用户等级配置
 */
export function systemUserLevelConfigApi(id) {
  return request({
    url: "/admin/platform/system/user/level/get/config",
    method: 'GET'
  });
}

/**
 * @description 编辑用户等级配置
 */
export function systemUserLevelUpdateConfigApi(data) {
  return request({
    url: "/admin/platform/system/user/level/update/config",
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取用户等级规则
 */
export function systemUserLevelRuleApi(id) {
  return request({
    url: "/admin/platform/system/user/level/get/rule",
    method: 'GET'
  });
}

/**
 * @description 编辑用户等级规则
 */
export function systemUserLevelUpdateRuleApi(data) {
  return request({
    url: "/admin/platform/system/user/level/update/rule",
    method: 'POST',
    data: data
  });
}

/**
 * @description 公司区域用户列表
 */
export function agentUserCompanyPage(params) {
  return request({
    url: "/admin/agent/user/company/page",
    method: 'GET',
    params: params
  });
}

/**
 * @description 获取城市tree结构的列表
 */
export function merchantCityRegionTree() {
  return request({
    url: "/admin/merchant/city/region/city/tree",
    method: 'GET'
  });
}

/**
 * @description 公司用户删除
 */
export function agentUserCompanyDel(params) {
  return request({
    url: "/admin/agent/user/company/del",
    method: 'GET',
    params: params
  });
}

/**
 * @description 分公司用户新增
 */
export function agentUserCompanyAdd(params) {
  return request({
    url: "/admin/agent/user/company/add",
    method: 'GET',
    params: params
  });
}

/**
 * @description 区域用户列表
 */
export function agentUserRegionPage(params) {
  return request({
    url: "/admin/agent/user/region/page",
    method: 'GET',
    params: params
  });
}

/**
 * @description 区域用户删除
 */
export function agentUserRegionDel(params) {
  return request({
    url: "/admin/agent/user/region/del",
    method: 'GET',
    params: params
  });
}

/**
 * @description 区域用户新增
 */
export function agentUserRegionAdd(params) {
  return request({
    url: "/admin/agent/user/region/add",
    method: 'GET',
    params: params
  });
}

/**
 * @description 用户注册
 */
export function userRegisterPhone(data) {
  return request({
    url: "/admin/platform/user/register/phone",
    method: 'POST',
    data: data
  });
}

/**
 * @description 上传
 */
export function userOrderimportSend(data) {
  return request({
    url: "/admin/merchant/order/order/importSend",
    method: 'POST',
    data: data,
    timeout: 1800000
  });
}

/**
 * @description 用户注册
 */
export function userPlatformUserUpdate(data) {
  return request({
    url: "/admin/platform/user/update/user",
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取手机号
 */
export function platformUserPhone(params) {
  return request({
    url: "/admin/platform/user/phone",
    method: 'GET',
    params: params
  });
}

/**
 * @description 批量导入
 */
export function platformUserImport(data) {
  var config = {
    url: "/admin/platform/user/import",
    method: 'POST',
    data: data,
    timeout: 1800000
  };
  return request(config);
}
/**
 * @description 获取表单配置，只需传入表单的字段key
 */
export function platformSystemConfigGetuniq(params) {
  return request({
    url: "/admin/platform/system/config/getuniq",
    method: 'GET',
    params: params
  });
}

/**
 * @description 线下补贴列表
 */
export function agentUserofflinesubsidyPage(params) {
  return request({
    url: "/admin/agent/user/offline/subsidy/page",
    method: 'GET',
    params: params
  });
}

/**
 * @description 线下补贴删除
 */
export function agentUserofflinesubsidydel(params) {
  return request({
    url: "/admin/agent/user/offline/subsidy/del",
    method: 'GET',
    params: params
  });
}

/**
 * @description 线下补贴新增
 */
export function agentUserofflinesubsidyadd(data) {
  return request({
    url: "/admin/agent/user/offline/subsidy/add",
    method: 'POST',
    data: data
  });
}

/**
 * @description 线下补贴新增
 */
export function agentUserofflinesubsidyedit(data) {
  return request({
    url: "/admin/agent/user/offline/subsidy/edit",
    method: 'POST',
    data: data
  });
}

/**
 * @description 升星查看
 */
export function agentUsercapaxsuserupgradeList(params) {
  return request({
    url: "/admin/agent/user/capa/xs/user/upgradeList",
    method: 'GET',
    params: params
  });
}

/**
 * @description 安置关系图
 */
export function agentUserrelationflowgplot(params) {
  return request({
    url: "/admin/agent/user/relation/flow/gplot",
    method: 'GET',
    params: params
  });
}

/**
 * @description 销售关系图
 */
export function agentUserinvitationflowgplot(params) {
  return request({
    url: "/admin/agent/user/invitation/flow/gplot",
    method: 'GET',
    params: params
  });
}

/**
 * @description 6个1星
 */
export function adminplatformuserregistersix(data) {
  return request({
    url: "/admin/platform/user/register/six",
    method: 'POST',
    data: data
  });
}

/**
 * @description 3个1星
 */
export function adminplatformuserregisterthree(data) {
  return request({
    url: "/admin/platform/user/register/three",
    method: 'POST',
    data: data
  });
}

/**
 * @description 批发平台关联
 */
export function wholerelevancelist(params) {
  return request({
    url: "/admin/agent/whole/relevance/page/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 批发平台增加
 */

export function wholerelevanceadd(data) {
  return request({
    url: "/admin/agent/whole/relevance/add",
    method: 'POST',
    data: data
  });
}

/**
 * @description 库存管理列表
 */
export function agentplatformproductrepertorylist(params) {
  return request({
    url: "/admin/agent/platform/product/repertory/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 库存管理列表导出
 */
export function agentplatformproductrepertoryexcel(params) {
  return request({
    url: "/admin/agent/platform/product/repertory/excel",
    method: 'GET',
    params: params
  });
}
/**
 * @description 库存管理调拨商品下拉项
 */
export function agentplatformproductrepertoryuserrepertory(params) {
  return request({
    url: "/admin/agent/platform/product/repertory/user/repertory",
    method: 'GET',
    params: params
  });
}
/**
 * @description 库存管理列表调拨库存
 */
export function agentplatformproductrepertoryallot(data) {
  return request({
    url: "/admin/agent/platform/product/repertory/allot",
    method: 'POST',
    data: data
  });
}
/**
 * @description 库存管理列表库存明细
 */
export function agentplatformproductrepertoryflowlist(params) {
  return request({
    url: "/admin/agent/platform/product/repertory/flow/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 赠送明细列表
 */
export function agentuserscorelist(params) {
  return request({
    url: "/admin/agent/user/score/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 赠送明细查看列表
 */
export function agentuserscoreflowlist(params) {
  return request({
    url: "/admin/agent/user/score/flow/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 赠送明细导出
 */
export function agentuserscoreexcel(params) {
  return request({
    url: "/admin/agent/user/score/excel",
    method: 'GET',
    params: params
  });
}
/**
 * @description 赠送明细修改分值
 */
export function agentuserscoreedit(data) {
  return request({
    url: "/admin/agent/user/score/edit",
    method: 'POST',
    data: data
  });
}

/**
 * @description 检测报告导出
 */
export function agentuserskinexcel(params) {
  return request({
    url: "/admin/agent/user/skin/excel",
    method: 'GET',
    params: params
  });
}

/**
 * @description 检测报告列表
 */
export function agentuserskinlist(params) {
  return request({
    url: "/admin/agent/user/skin/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 库存管理公司调拨
 */
export function agentplatformproductrepertorycompany(data) {
  return request({
    url: "/admin/agent/platform/product/repertory/company",
    method: 'POST',
    data: data
  });
}

/**
 * @description 库存管理公司调拨商品下拉
 */
export function merchantproductnoRef() {
  return request({
    url: "/admin/merchant/product/noRef",
    method: 'GET'
  });
}
/**
 * @description 库存管理编辑
 */
export function agentplatformproductrepertoryedit(data) {
  return request({
    url: "/admin/agent/platform/product/repertory/edit",
    method: 'POST',
    data: data
  });
}

/**
 * @description 补缴列表
 */
export function userFillScorePage(params) {
  return request({
    url: "/admin/agent/user/fill/score/page",
    method: 'GET',
    params: params
  });
}

/**
 * @description 补缴增加
 */
export function userFillScoreAdd(data) {
  return request({
    url: "/admin/agent/user/fill/score/add",
    method: 'POST',
    data: data
  });
}
export function userFillScoreDelete(params) {
  return request({
    url: "/admin/agent/user/fill/score/delete",
    method: 'get',
    params: params
  });
}

/**
 * @description 用户折扣
 */
// 列表
export function userDiscountList(params) {
  return request({
    url: "/admin/platform/user/rebuy/discount/config/list",
    method: 'get',
    params: params
  });
}
// 详情
export function userDiscountInfo(id) {
  return request({
    url: "/admin/platform/user/rebuy/discount/config/info/".concat(id),
    method: 'get'
  });
}
// 新增
export function userDiscountSave(data) {
  return request({
    url: "/admin/platform/user/rebuy/discount/config/save",
    method: 'POST',
    data: data
  });
}
// 编辑
export function userDiscountUpdate(data) {
  return request({
    url: "/admin/platform/user/rebuy/discount/config/update",
    method: 'POST',
    data: data
  });
}
// 删除
export function userDiscountDelete(id) {
  return request({
    url: "/admin/platform/user/rebuy/discount/config/delete/".concat(id),
    method: 'POST'
  });
}